module.exports = __webpack_public_path__ + "static/media/Cabinet3_Before.fb88e831.jpg";